import { api } from '@/shared/api';
import { apiRoutes } from '@/shared/routes';
import { DateHistoryEntry } from './types';
import type { WireResponse } from '@/shared/generated/wire';

export function fetchDateHistory(): Promise<DateHistoryEntry[]> {
  return api.get<WireResponse<'/app/api/stats/date_history', 'get', 200>>(apiRoutes.statsDateHistory);
}
